/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { Schema } from '@jalik/schema'
import {
  PER_MONTH,
  PER_QUARTER,
  PER_SEMESTER,
  PER_YEAR
} from '../lib/period.mjs'

const LeaseChargeSchema = new Schema({
  id: {
    type: 'integer'
  },
  amount: {
    type: 'integer',
    required: true,
    min: 0
  },
  frequency: {
    type: 'string',
    required: true,
    allowed: [PER_MONTH, PER_QUARTER, PER_SEMESTER, PER_YEAR]
  },
  label: {
    type: 'string',
    required: true,
    maxLength: 255
  },
  provisioned: {
    type: 'boolean',
    required: true
  },
  cps: {
    type: 'integer',
    required: true,
    min: 0
  },
  vat: {
    type: 'integer',
    required: true,
    min: 0
  }
})

export default LeaseChargeSchema
